// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import SettingFilledSvg from "@ant-design/icons-svg/es/asn/SettingFilled";
import AntdIcon from '../components/AntdIcon';

var SettingFilled = function SettingFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: SettingFilledSvg
  }));
};

SettingFilled.displayName = 'SettingFilled';
export default React.forwardRef(SettingFilled);